import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state={ //要设置的全局访问的state对象,赋予初始属性值
  network: true,
	isLogin:false,
	userInfo:null,
};

const getters = {   //实时监听state值的变化(最新状态)
   
};

const mutations = {
    //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);

	//修改网络状态
    changeNetwork(state,vlaue){ 
       state.network = vlaue
    },
	changeIsLogin(state,vlaue){ 
       state.isLogin = vlaue
    },
	changeUserInfo(state,vlaue){
	   state.userInfo = vlaue
	}
};

const store = new Vuex.Store({
   state, // 挂载存取数据功能
   getters, //挂载数据计算功能
   mutations // 挂载函数功能
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js